var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAedFlag(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 12,
    viewBox: "0 0 16 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Flag Pack",
    clipPath: "url(#clip0_8987_24943)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M17.3635 3.95673H4.54029V-0.0695683H17.0668C17.2307 -0.0695683 17.3635 0.0632875 17.3635 0.227127L17.3635 3.95673Z",
    fill: "#73AF00",
    stroke: "#3A3D5A",
    strokeWidth: 0.0503165
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M17.0668 12.1101H4.54029V8.08375H17.3635V11.8134C17.3635 11.9772 17.2306 12.1101 17.0668 12.1101Z",
    fill: "#464655",
    stroke: "#3A3D5A",
    strokeWidth: 0.0503165
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_3",
    d: "M4.54029 8.03317V4.00709H17.3634V8.03317H4.54029Z",
    fill: "#F5F5F5",
    stroke: "#3A3D5A",
    strokeWidth: 0.0503165
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_4",
    d: "M4.49012 12.11H-0.955978C-1.11982 12.11 -1.25267 11.9772 -1.25267 11.8133V0.227127C-1.25267 0.0632873 -1.11982 -0.0695683 -0.955978 -0.0695683H4.49012V12.11Z",
    fill: "#FF4B55",
    stroke: "#3A3D5A",
    strokeWidth: 0.0503165
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_8987_24943"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 12,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAedFlag);
export default __webpack_public_path__ + "static/media/AED_flag.a8a4763fbe03a7ac01b89ab227f9f890.svg";
export { ForwardRef as ReactComponent };